export const ACTIONS = ["list", "create", "revoke"] as const;
